/* KIDSpo 商品カード: お気に入り♡(localStorage) / クイック追加＋ */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var FAV_KEY = 'kidspo:favs';

  /* ---------------- お気に入り♡ ---------------- */
  function getFavs() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; }
    catch (e) { return []; }
  }
  function setFavs(list) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function paintFavs() {
    var favs = getFavs();
    document.querySelectorAll('[data-kidspo-fav]').forEach(function (btn) {
      var id = btn.getAttribute('data-product-id');
      var on = favs.indexOf(id) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.textContent = on ? '♥' : '♡';
    });
  }
  paintFavs();

  /* ---------------- クイック追加＋ ---------------- */
  function refreshDrawer(res) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && res && res.sections && typeof drawer.renderContents === 'function') {
      drawer.classList.remove('is-empty');
      drawer.renderContents(res);
      if (typeof drawer.open === 'function') drawer.open();
      return true;
    }
    return false;
  }

  function quickAdd(btn) {
    if (btn.classList.contains('is-loading')) return;
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    btn.classList.add('is-loading');
    btn.textContent = '…';

    fetch(root + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var available = (product.variants || []).filter(function (v) { return v.available; });
        // バリアントが1つだけ＝即カート。複数（サイズ選択が要る）＝商品ページへ。
        if (product.variants.length === 1 && available.length === 1) {
          return fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: available[0].id, quantity: 1 }],
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              btn.classList.remove('is-loading');
              btn.textContent = '＋';
              if (res.status) { window.location = root + 'products/' + handle; return; }
              if (!refreshDrawer(res)) window.location = root + 'cart';
            });
        } else {
          window.location = root + 'products/' + handle;
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.textContent = '＋';
        window.location = root + 'products/' + handle;
      });
  }

  /* ---------------- 委譲（動的追加カードにも効く） ---------------- */
  document.addEventListener('click', function (e) {
    var fav = e.target.closest('[data-kidspo-fav]');
    if (fav) {
      e.preventDefault();
      e.stopPropagation();
      var id = fav.getAttribute('data-product-id');
      var favs = getFavs();
      var idx = favs.indexOf(id);
      if (idx === -1) favs.push(id); else favs.splice(idx, 1);
      setFavs(favs);
      paintFavs();
      return;
    }
    var qa = e.target.closest('[data-kidspo-quickadd]');
    if (qa) {
      e.preventDefault();
      e.stopPropagation();
      quickAdd(qa);
    }
  });
})();
